// extracted by css-extract-rspack-plugin
export default {"root":"root-WtHAH7","black":"black-J98gn_","indicator":"indicator-Fetkp9","item":"item-sqaKKG","active":"active-eGz08y"};